export const UserInfo = {
	url: '/info?topic',
	title: 'Info',
	template: '<info-page></info-page>',
	params: {
		topic: null,
		data: null,
	},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userInfoPageMod" */
			'@Containers/user-info-page/user-info-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
